<template>
  <div class="modal fade" data-bs-backdrop="static" ref="modalEle" :size="size">
    <div
      class="modal-dialog modal-dialog-centered"
      :class="{
        'modal-sm': size == 'sm',
        'modal-lg': size == 'lg',
        'modal-xl': size == 'xl',
      }"
    >
      <div class="modal-content">
        <div
          v-if="$slots['modalheader']"
          class="modal-header"
          :class="headerClass"
        >
          <slot name="modalheader"></slot>
        </div>
        <div v-if="$slots['default']" class="modal-body" :class="bodyClass">
          <slot name="default"></slot>
        </div>
        <div
          v-if="$slots['modalfooter']"
          class="modal-footer"
          :class="footerClass"
        >
          <slot name="modalfooter"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { onMounted, ref, watch } from "vue";
export default {
  props: {
    modalShow: Boolean,
    size: String,
    headerClass: String,
    bodyClass: String,
    footerClass: String,
  },
  setup(props) {
    const modalEle = ref(null);
    const thisModalObj = ref(null);
    onMounted(() => {
      thisModalObj.value = new Modal(modalEle.value);
    });

    watch(
      () => props.modalShow,
      (newValue) => {
        if (newValue == true) {
          thisModalObj.value.show();
        } else {
          thisModalObj.value.hide();
        }
      }
    );
    return {
      modalEle,
    };
  },
};
</script>

<style scoped>
.form-control {
  position: relative;
  height: auto;
  box-sizing: border-box;
  padding: 10px;
  border-bottom: 1px solid black;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  border-radius: 0px;
  box-shadow: none;
}
.form-control:focus {
  box-shadow: none;
  z-index: 2;
}
.inputdiv label {
  float: left;
  margin-right: 5px;
  margin-top: 5px;
  font-size: 16px;
}
.inputdiv div {
  overflow: hidden;
  margin-bottom: 20px;
}
.inputdiv input {
  width: 100%;
  display: block;
}
.wrongpwd {
  background-color: #fee;
  border-color: #e99;
}
h5,
h6 {
  margin: 0 auto !important;
}
textarea {
  border: 1px solid black;
  width: 280px;
  height: 120px;
  resize: none;
}
</style>
<style lang="scss">
.modal-header {
  background-color: var(--main-bg-color);
  height: 40px;
}
.modal-header .close {
  color: var(--main-font-color);
  padding: 0.5rem;
  margin: -1rem -1rem -1rem auto;
  background-color: transparent;
  border: 0;
  appearance: none;
}
.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  text-shadow: 0 1px 0 #fff;
}
@media (min-width: 1500px) {
  .modal-xl {
    max-width: 1460px;
  }
}
</style>
